import { ParticipantRegistrationMetric } from 'app/library/participant-registration-metric/models/participant-registration-metric.model';
import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { Section } from './section.model';
import { SectionMetric } from './section-metrics.model';

export class SectionStateModel extends EntityStateModel<Section> {
    participantScormRegistrationMetrics?: ParticipantRegistrationMetric;
    latestParticipantScormMetricsRequestSectionId?: string | null;
    assessmentSectionMetrics?: SectionMetric;
}
